import styled from 'styled-components';

export const BenchmarkFormStyles = styled.div`
  background: #f8f8f8;
  padding-top: 20px;
  padding-bottom: 20px;

   /* Fix col-auto padding issues */
  .col-auto {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  /* Handle flexbox + grid combinations */
  .d-flex.flex-wrap > .col-auto {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  & > div[class*='PanelStyles__Container'] {
    padding: 0px;
  }

  div[class*='__RadioWrapper'] > div[class*='__Label'] {
    line-height: 0px !important;
    padding-top: 5px;
  }

  button.react-datepicker__close-icon {
    display: none;
  }

  div > span[class*='LabelContainer'] {
    padding-bottom: 5px;
    font-weight: bold;
    font-size: 13px;
    text-align: top;
  }

  div > svg {
    vertical-align: bottom;
  }

  .row-gap {
    row-gap: 20px;
  }
`;

export const AlertStyle = styled.div`
  div.alert {
    border-left-width: 10px;
    padding-bottom: 0px;
  }

  div.alert.alert-warning {
    border-left-color: #e88407;
    background-color: #feead2 !important;
    color: black;
  }

  div.alert-heading {
    font-size: 13px !important;
    color: #e88407;
    text-transform: uppercase !important;
  }

  div.alert-heading > svg {
    margin-right: 10px;
    vertical-align: text-bottom;
  }
`;

export const BenchmarkFormTitle = styled.h1`
  font-weight: 300;
  padding: 20px 26px 0px 0px;
  font-size: 28px;
  line-height: 31.5px;
`;
